import { z } from 'zod';

/** A single editable leaf (member / added-member / overhead). All fields optional. */
const leafSchema = z
  .object({
    invoicedBy: z.string(),
    memberId: z.number().nullable(),
    description: z.string(),
    hours: z.number(),
    effectiveRate: z.number(),
  })
  .partial();

/**
 * The form is keyed by STABLE ENTITY IDS, not array index (see `getInvoiceFieldName`):
 * `project.p{projectId}.member.m{memberId}.hours`, etc. So the shape is nested records
 * rather than arrays. The resolver is only used for typing — submission is gated by
 * `useInvoicesGenerateDisabled`, not this schema — so a permissive record shape is enough.
 */
export const generateInvoicesValidationSchema = z.object({
  project: z.record(
    z.string(),
    z.object({
      member: z.record(z.string(), leafSchema).optional(),
      addedMember: z.record(z.string(), leafSchema).optional(),
      overhead: z.record(z.string(), leafSchema).optional(),
    })
  ),
});

export type GenerateInvoicesTableFormValues = z.infer<typeof generateInvoicesValidationSchema>;
